<template>
	<div class="main-header " :style="setStyle()" :class="[params.type=='1'?'main-style1':'']" >
		<!-- 设置和客服的功能按键 -->
		<div class="info-icon">
			<img v-if="$util.inArray('set', styles.show)" :src="styles.setimg"  ></img>
			<button v-if="$util.inArray('service', styles.show)" open-type="contact" type="default">
				<img :src="styles.serviceimg" mode="" style="margin-left: 10px"></img>
			</button>
		</div>
		<div class="user-info">
			<div class="user-avatar" >
				<img style="width: 60px;height:60px" src="https://mp.mocols.com/common/weishop/default-avatar1.png" alt="" />
			</div>
			<div class="user-content">
				<!-- 会员昵称 -->
				<div :style="{color:styles.namecolor}" class="nick-name oneline-hide" >普通用户</div>
	
				<div style="display: flex;">
					<!-- 会员无等级时显示手机号 -->
					<!-- <div v-if="userInfo?.mobile" class="mobile">
						{{ userInfo?.mobile || '' }}
					</div> -->
					<!-- 会员等级 -->
					<div  v-if="$util.inArray('member', params.level)" :style="{background:styles.levelbg}" class="user-grade" style="margin-right: 10px;">
						<div class="user-grade_icon">
							<img class="image" :src="styles.levelimg"></img>
						</div>
						<div :style="{color:styles.levelcolor}" class="user-grade_name">
							<span>黄金会员</span>
						</div>
					</div>
					
					<div v-if="$util.inArray('distribution', params.level)" :style="{background:styles.distributionbg}" class="user-grade" >
						<div class="user-grade_icon distribution_box">
							<img class="distribution_image" :src="styles.distributionimg"></img>
						</div>
						<div :style="{color:styles.distributioncolor}" class="distribution_name">
							<span>分销等级</span>
						</div>
					</div>
				</div>
	
				<!-- 会员无等级也无手机号的时候显示普通会员 -->
				<!-- <div  class="user-grade">
					<div class="user-grade_icon">
						<img class="image" src="https://mp.mocols.com/common/weishop/mine/grade.png"></img>
					</div>
					<div class="user-grade_name">
						<span>普通会员</span>
					</div>
				</div> -->
			</div>
		</div>
		<!-- 我的钱包 -->
		<div v-if="params.but.length>0" class="my-asset">
			<div class="asset-left " style="display: flex;width: 100%;justify-content: center;">
				<div v-if="$util.inArray('balance', params.but)"
					class="asset-left-item"
					style="max-width: 100px;flex:1"
				>
					<div class="item-value dis-flex flex-x-center">
						<span class="" :style="{color:styles.financenum}">*</span>
					</div>
					<div class="item-name dis-flex flex-x-center">
						<span :style="{color:styles.financetext}">余额</span>
					</div>
				</div>
				<div v-if="$util.inArray('points', params.but)" class="asset-left-item" style="flex:1">
					<div class="item-value dis-flex flex-x-center">
						<span class="":style="{color:styles.financenum}">*</span>
					</div>
					<div class="item-name dis-flex flex-x-center">
						<span :style="{color:styles.financetext}">积分</span>
					</div>
				</div>
				<div v-if="$util.inArray('coupon', params.but)" class="asset-left-item" style="flex:1">
					<div class="item-value dis-flex flex-x-center">
						<span class="":style="{color:styles.financenum}">*</span>
					</div>
					<div class="item-name dis-flex flex-x-center">
						<span :style="{color:styles.financetext}">礼券</span>
					</div>
				</div>
				<div v-if="$util.inArray('contribution', params.but)" class="asset-left-item" style="flex:1" >
					<div class="item-value dis-flex flex-x-center">
						<span class="":style="{color:styles.financenum}">*</span>
					</div>
					<div class="item-name dis-flex flex-x-center">
						<span :style="{color:styles.financetext}">贡献值</span>
					</div>
				</div>
				<div v-if="$util.inArray('life', params.but)" class="asset-left-item" style="flex:1" >
					<div class="item-value dis-flex flex-x-center">
						<span class="":style="{color:styles.financenum}">*</span>
					</div>
					<div class="item-name dis-flex flex-x-center">
						<span :style="{color:styles.financetext}">礼品卡</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default {
		props: {
			styles:{
				type:Object
			},
			// 标签文字
			params: {
				type:Object
			},
		},
		methods:{
			setStyle(){
				let _this = this
				if(_this.params.type == '2'){
					return {background:_this.styles.background}
				}else if(_this.params.type == '3'){
					return {
						backgroundImage:'url('+_this.styles.backgroundimg+')',
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.my-asset {
		display: flex;
		padding: 20px 0 20px 0;
		.asset-right {
			// width: 100px;
		}
	
		.asset-right-item {
			text-align: center;
			color: #545454;
	
			.item-value {
				font-size: 17px;
				color: #f00;
				font-weight: 600;
				width: 25px;
				margin: 0 auto;
	
				img {
					width: 100%;
					height: 100%;
				}
	
				.oneline-hide {
				}
			}
	
			.item-icon {
			}
	
			.item-name {
				margin-top: 5px;
				font-size: 13px;
			}
		}
	
		.asset-left-item {
			// max-width: 90px;
			text-align: center;
			color: #666;
			padding: 0 8px;
			.item-value {
				font-size: 17px;
				color: #f00;
				font-weight: 600;
				width: 25px;
				height: 25px;
				margin: 0 auto;
	
				image {
					width: 100%;
					height: 100%;
				}
			}
	
			.item-name {
				margin-top: 7px;
				font-size: 13px;
			}
		}
	}
	.main-style1{
		background-position:
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px,
			0px 0px;
		background-image:
			radial-gradient(18% 28% at 24% 50%, #ffffffff 7%, #073aff00 100%),
			radial-gradient(18% 28% at 18% 71%, #fbf7f759 6%, #073aff00 100%),
			radial-gradient(70% 53% at 36% 76%, #f4f9faff 0%, #073aff00 100%),
			radial-gradient(42% 53% at 15% 94%, #f9f3f3ff 7%, #073aff00 100%),
			radial-gradient(42% 53% at 34% 72%, #fcf8f8ff 7%, #073aff00 100%),
			radial-gradient(18% 28% at 35% 87%, #f3ebebff 7%, #073aff00 100%),
			radial-gradient(31% 43% at 7% 98%, #f9f9f9ff 24%, #f9f9f9ff 40%, #f9f9f9ff 51%, #073aff00 100%),
			radial-gradient(21% 37% at 72% 23%, #f9f9f9ff 24%, #073aff00 100%),
			radial-gradient(35% 56% at 91% 74%, #f9f9f9ff 0%, #f9f9f9ff 23%, #073aff00 100%),
			radial-gradient(74% 86% at 67% 38%, #f9f9f9ff 0%, #f9f9f9ff 1%, #f9f9f9ff 1%, #f9f9f9ff 24%, #073aff00 100%),
			linear-gradient(21deg, #f9f9f9ff 0%, #f9f9f9ff 45%, #f00 83%); // background: #f00;
	}
	.main-header {
		position: relative;
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: center;
		background-size: cover;      /* 保持宽高比，完全覆盖容器 */
		  background-position: center; /* 将图片居中显示，可根据需要调整 */
		  background-repeat: no-repeat; /* 避免重复 */
		.bg-image {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
		.user-info {
			display: flex;
			z-index: 1;
			padding: 0 20px;
			margin-top: 45px;
			padding-bottom: 20px;
			.user-content {
				display: flex;
				flex-direction: column;
				justify-content: center;
				margin-left: 15px;
				color: #c59a46;
				color: #000;
	
				.nick-name {
					font-size: 17px;
					font-weight: bold;
					// max-width: 300rpx;
				}
	
				.mobile {
					margin-top: 12px;
					font-size: 24px;
				}
	
				.user-grade {
					align-self: baseline;
					display: flex;
					align-items: center;
					background: #3c3c3c;
					background: #f00;
					margin-top: 10px;
					border-radius: 3px;
					// padding: 2px 4px;
					height:20px;
	
					.user-grade_icon .image {
						display: block;
						// width: 16px;
						height: 20px;
					}
	
					.user-grade_name {
						margin-left: 2px;
						font-size: 10px;
						color: #fff;
						font-weight: bold;
						margin-right: 7px;
					}
					.distribution_box{
						display: block;
						height: 20px;
					}
					.distribution_image{
						display: block;
						height: 16px;
						margin-left: 6px;
						margin-top: 2px;
					}
					.distribution_name{
						margin-left: 3px;
						font-size: 10px;
						color: #fff;
						margin-right: 7px;
						font-weight: bold;
					}
				}
	
				.login-tips {
					margin-top: 6px;
					font-size: 15px;
				}
			}
		}
	
		.info-icon {
			z-index: 99;
			position: absolute;
			right: 25px;
			top:80px;
			transform: translateY(-50%);
			display: flex;
	
			img {
				width: 23px;
				height: 23px;
			}
	
			button {
				background: transparent;
				border: none;
				padding: 0;
				color: #95989d;
				font: inherit;
				cursor: pointer;
			}
		}
	}
</style>